<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_mentalDrawing') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
            span(slot="value") {{ $i18n.tc(`trainer.trainer_gameFormSetting_${parameters.viewType}`, 1) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
            span(slot="value") {{ parameters.showTime + ' ' +$i18n.t('trainer.trainer_gameFormSettingValue_seconds')}}
        game-preview-setting
            span(slot="name") {{ $i18n.t('progress.progress_preview_timeLimit') }}
            span(slot="value") {{ parameters.timeLimit + ' ' + $i18n.t('trainer.trainer_gameFormSettingValue_minutes')}}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_simultaneously') }}
            span(slot="value") {{ parameters.simultaneously ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_differentFigures') }}
            span(slot="value") {{ parameters.differentFigures ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
            span(slot="value") {{ parameters.isMusicOn ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String,
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
    };
</script>
